import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { Briefing } from "../../shared/types";
import { fuzzy } from "../../shared/utils";

export const filterBriefingUsers = (search: string) => {
	return (source$: Observable<Briefing[]>) =>
		source$.pipe(
			map((briefings) => {
				if (!search) {
					return briefings;
				}

				const briefingsWithFullName = briefings.map((briefing) => ({
					...briefing,
					fullName: `${briefing.resident.firstName} ${briefing.resident.name}`,
				}));

				return fuzzy(briefingsWithFullName, search, "fullName");
			}),
		);
};

export const filterBriefingDepartments = (departmentIds: { id: string }[]) => {
	return (source$: Observable<Briefing[]>) =>
		source$.pipe(
			map((briefings) =>
				(briefings || []).filter((briefing) => {
					if (!departmentIds || departmentIds.length === 0) {
						return true;
					}

					let hasDepartment = false;

					for (const department of departmentIds) {
						// @ts-expect-error TS18048
						if (briefing.departments.some((briefingDepartment) => briefingDepartment.id === department.id)) {
							hasDepartment = true;
						}
					}

					return hasDepartment;
				}),
			),
		);
};
